import { useState } from 'react';
import DOMPurify from 'dompurify';
import { RichTextEditor } from '@/components/ui/rich-text-editor';
import  DateTimePicker  from '@/components/ui/date-picker/date-picker';

export default function EditorDemoPage() {
  const [content, setContent] = useState('');

  const[date, setDate] = useState<Date | undefined>(undefined);
  return (
    <div className='container mx-auto max-w-3xl py-10 space-y-6'>
      <div>
        <h1 className='text-2xl font-bold'>Rich Text Editor Demo</h1>
      </div>

      <div className='space-y-2'>
        <RichTextEditor
          value={content}
          onChange={setContent}
          placeholder='Enter something...'
        />
      </div>

      <div className='space-y-2'>
        <label className='text-sm font-medium'>Output</label>
        <div
          className='prose prose-sm max-w-none rounded-md border p-4 min-h-[60px]'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(content) || '<p class="text-muted-foreground">(empty)</p>',
          }}
        />
      </div>

      <div className='space-y-2'>
        <label className='text-sm font-medium'>HTML Output</label>
        <pre className='rounded-md border bg-muted p-4 text-sm overflow-auto max-h-48'>
          {content || '(empty)'}
        </pre>
      </div>

      <div>
        <DateTimePicker value={date} onChange={(date) => setDate(date)}></DateTimePicker>
      </div>
    </div>
  );
}
